/** 广场 */
export const plaza = [
  {
    name: 'getTabs', // 广场首页的标签tabs
    isMock: false,
  },
  {
    name: 'getPost', // ai帖子-详情
    isMock: false,
  },
  {
    name: 'aiArtworkPostSame', // 一键同款-生成ai创作
    isMock: false,
  },
  {
    name: 'createPost', // 创建帖子
    isMock: false,
  },
  {
    name: 'updatePost', // 编辑帖子
    isMock: false,
  },
  {
    name: 'downloadImage', // 下载原图
    isMock: false,
  },
  {
    name: 'deleteSquarePost', // 删除帖子
    isMock: false,
  },
  {
    name: 'getComplainTypeList', // 获取投诉类型列表
    isMock: false,
  },
]
